import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';
import { usePermission } from '../context/PermissionContext';

export default function ServicePackagesPage() {
  const navigate = useNavigate();
  const { canPerformAction } = usePermission();
  const [pkgs, setPkgs] = useState([]);
  const [q, setQ] = useState('');

  const load = async () => {
    try {
      const sp = new URLSearchParams();
      if (q) sp.set('q', q);
      const r = await api.get(`/service-packages${sp.toString()?`?${sp}`:''}`);
      setPkgs(r);
    } catch (e) { console.error(e); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const remove = async (id) => {
    if (!window.confirm('이 서비스 패키지를 삭제하시겠습니까?')) return;
    try { await api.del(`/service-packages/${id}`); await load(); }
    catch (e) { alert(e.message); }
  };

  return (
    <div>
      <div className="card">
        <div className="card-header">
          <div className="card-title">서비스 패키지</div>
          {canPerformAction('서비스 패키지 등록/편집') && (
            <button className="btn btn-primary btn-sm" onClick={()=>navigate('/services/new')}>+ 패키지 등록</button>
          )}
        </div>
        <div style={{display:'flex',gap:8,marginBottom:12}}>
          <input className="form-input" style={{flex:1}} value={q} onChange={e=>setQ(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')load();}} placeholder="이름·코드 검색" />
          <button className="btn btn-outline btn-sm" onClick={load}>검색</button>
        </div>

        {pkgs.length === 0 ? (
          <div style={{textAlign:'center',padding:32,color:'#94a3b8'}}>등록된 서비스 패키지가 없습니다.</div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:14}}>
            {pkgs.map(p => (
              <div key={p.id} style={{border:'1px solid #e2e8f0',borderRadius:10,padding:14,background:'#fff'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:8}}>
                  <div style={{flex:1}}>
                    <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
                      <span style={{fontFamily:'monospace',fontSize:11,color:'#64748b',background:'#f1f5f9',padding:'2px 8px',borderRadius:6}}>{p.code}</span>
                      <span style={{fontSize:15,fontWeight:700}}>{p.name}</span>
                      {p.category && <span className="badge badge-blue">{p.category}</span>}
                      <span className="badge badge-gray">Task {p.task_count||0}</span>
                    </div>
                    {p.notes && <div style={{fontSize:12,color:'#475569',whiteSpace:'pre-wrap',marginTop:4}}>{p.notes}</div>}
                  </div>
                  <div style={{whiteSpace:'nowrap'}}>
                    {canPerformAction('서비스 패키지 등록/편집') && (
                      <button className="btn btn-outline btn-sm" onClick={()=>navigate(`/services/${p.id}/edit`)} style={{marginRight:4}}>수정</button>
                    )}
                    {canPerformAction('서비스 패키지 삭제') && (
                      <button className="btn btn-danger btn-sm" onClick={()=>remove(p.id)}>삭제</button>
                    )}
                  </div>
                </div>

                {(p.tasks||[]).length > 0 ? (
                  <div style={{borderTop:'1px solid #f1f5f9',paddingTop:10,marginTop:6}}>
                    <div style={{fontSize:11,fontWeight:700,color:'#94a3b8',marginBottom:6}}>세부 내역</div>
                    <div style={{overflowX:'auto'}}><table style={{fontSize:11}}>
                      <thead>
                        <tr>
                          <th style={{width:30}}>NO</th>
                          <th>품명</th>
                          <th style={{width:120}}>조사용직무</th>
                          <th style={{width:130}}>ITSQF 직무</th>
                          <th style={{width:90}}>인력등급</th>
                          <th style={{width:50,textAlign:'center'}}>인원</th>
                          <th style={{width:60,textAlign:'center'}}>M/M</th>
                          <th style={{width:110,textAlign:'right'}}>월단가</th>
                        </tr>
                      </thead>
                      <tbody>
                        {p.tasks.map((t,i) => (
                          <tr key={t.id}>
                            <td style={{textAlign:'center',color:'#94a3b8'}}>{i+1}</td>
                            <td style={{whiteSpace:'pre-wrap',padding:'4px 6px'}}>{t.task_name||'-'}</td>
                            <td>{t.survey_job_name||'-'}</td>
                            <td>{t.itsqf_job_name||'-'}</td>
                            <td>{t.skill_level||'-'}</td>
                            <td style={{textAlign:'center'}}>{t.default_headcount||1}</td>
                            <td style={{textAlign:'center'}}>{Number(t.default_mm||0).toFixed(2)}</td>
                            <td style={{textAlign:'right'}}>{t.default_monthly_rate?`₩${Number(t.default_monthly_rate).toLocaleString()}`:'-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table></div>
                  </div>
                ) : (
                  <div style={{fontSize:11,color:'#94a3b8',padding:'6px 0',borderTop:'1px solid #f1f5f9',marginTop:6}}>등록된 Task 가 없습니다.</div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
